<template>
  <div>
    <v-container class="pt-0">
      <span class="headline">{{$t('friendshiprequests.title')}}</span>
      <div v-if="friendshipRequests.length > 0">
        <v-row
          v-for="friendRequest in friendshipRequests"
          v-bind:key="friendRequest.id"
          class="align-center"
        >
          <v-col>
            <user-widget :user="friendRequest" :showDefaultActions="[]" />
          </v-col>
          <v-col cols="auto" class="text-right px-0">
            <v-btn
              class="mx-2 primary"
              icon
              large
              @click="acceptFriendship(friendRequest)"
              :disabled="loading"
            >
              <v-icon>mdi-check-bold</v-icon>
            </v-btn>
            <v-btn
              class="mx-2 error"
              icon
              large
              @click="declineFriendship(friendRequest)"
              :disabled="loading"
            >
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <v-row v-else>
        <v-col>
          <span
            class="caption"
          >{{$t('friendshiprequests.no-requests-found')}}</span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { ACTION_LOAD_FRIENDS } from "@/plugins/store.js";
// import HelpIcon from "@/widgets/HelpIcon";
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";

export default {
  name: "FriendshipRequests",

  components: {},

  data: () => ({
    loading: false
  }),

  computed: {
    friends: function() {
      return this.$store.state.friends;
    },
    friendshipRequests: function() {
      return this.$store.state.friendshipRequests;
    }
  },

  mounted() {
    this.resolveFriends();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },

  methods: {
    onRefreshData() {
      this.resolveFriends();
    },
    resolveFriends() {
      this.loading = true;
      this.$store
        .dispatch(ACTION_LOAD_FRIENDS)
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    decideFriendship(friend, accept) {
      this.loading = true;
      this.$api.decideFriendship(friend.uid, accept)
        .then(() => {
          this.loading = false;
          this.resolveFriends();
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        })
    },
    acceptFriendship(friend) {
      this.decideFriendship(friend, true);
    },
    declineFriendship(friend) {
      this.decideFriendship(friend, false);
    },
  }
};
</script>
